import { useContext, useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { CustomInput } from "../../components/CustomInput/CustomInput";
import { useForm } from "react-hook-form";
import { useMutationData } from "../../hooks/useMutationData";
import { AuthContext } from "../../context/AuthContext";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import SkyClear from '../../img/SkyClear.png';
const classes = require("./LoginScreen.module.css").default;

export const LoginScreen = () => {
  const [password, setPassword] = useState<boolean>(true);
  const { control, handleSubmit } = useForm();
  const mutateLogin = useMutationData({ url: "/login" });
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  // Redirigir automáticamente si ya está logueado
  useEffect(() => {
    if (authContext.isLoggedIn) {
      navigate("/");
    }
  }, [authContext.isLoggedIn, navigate]);

  const [isShaking, setIsShaking] = useState(false);

  const handleImageClick = () => {
    setIsShaking(true);
    setTimeout(() => setIsShaking(false), 500);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleSubmit(handleLogin)();
    }
  };

  const playNotificationSound = () => {
    const audio = new Audio(require("../../sound/login.wav"));
    audio.play();
  };

  const handleLogin = (data?: any) => {
    mutateLogin.mutate({ data, tipo: "post" }, {
      onSuccess: (data) => {
        authContext.login(
          data.data.data.usuario,
          data.data.data.token,
          data.data.data.rol
        );
        playNotificationSound();
        // Redirigir a la página principal después del login exitoso
        navigate("/");
      }
    });
  };

  return (
    <div className={classes.maincontainer} onKeyDown={handleKeyDown} tabIndex={0}>
      <div className="fixed inset-0 overflow-hidden bg-gradient-to-br from-blue-900 to-blue-950">
        <div className="absolute inset-0 bg-blue-950 opacity-60" />
        <motion.div
          className="absolute inset-0"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
            <motion.path
              d="M0,0 Q50,50 100,0 V100 H0 Z"
              fill="rgba(15, 23, 42, 0.2)"
              initial={{ d: "M0,100 Q50,100 100,100 V100 H0 Z" }}
              animate={{ d: "M0,0 Q50,50 100,0 V100 H0 Z" }}
              transition={{ duration: 10, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}
            />
            <motion.path
              d="M0,100 Q50,50 100,100 V100 H0 Z"
              fill="rgba(2, 6, 23, 0.15)"
              initial={{ d: "M0,100 Q50,100 100,100 V100 H0 Z" }}
              animate={{ d: "M0,100 Q50,50 100,100 V100 H0 Z" }}
              transition={{ duration: 10, repeat: Infinity, repeatType: "reverse", ease: "easeInOut", delay: 0.5 }}
            />
          </svg>
        </motion.div>
        <motion.div
          className="absolute bottom-0 left-0 w-full h-1/4 bg-blue-950 opacity-40"
          initial={{ y: "100%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: 1.5 }}
        />
      </div>

      <div className={classes.main}>
        {/* Logo */}
        <div className={classes.div}>
          <img
            className={`${classes.cogs} ${isShaking ? classes.shake : ""}`}
            src={SkyClear}
            alt="SKY"
            width={"130"}
            onClick={handleImageClick}
          />
        </div>

        {/* Título */}
        <label className={classes.label}>SKYANGEL CLEAR</label>

        {/* Formulario */}
        <Form>
          <div className="row">
            <div className="col-8 offset-2">
              <CustomInput
                control={control}
                name="correo"
                placeholder="Correo"
                rules={{
                  required: "Se requiere de un correo",
                  maxLength: {
                    value: 32,
                    message: "El correo tiene que ser menos a 32 caracteres",
                  },
                }}
              />
              <CustomInput
                control={control}
                name="contrasena"
                placeholder="Contraseña"
                rules={{
                  required: "Se requiere de una contraseña",
                }}
                tipo={password ? "password" : "text"}
              />
            </div>
            <div className="form-check col-md-6 col-sm-12 offset-3 mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefault"
                onClick={() => setPassword(!password)}
              />
              <label className="form-check-label text-light" htmlFor="flexCheckDefault">
                Mostrar contraseña
              </label>
            </div>
          </div>
          <button
            type="button"
            className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={handleSubmit(handleLogin)}
          >
            Iniciar sesión
          </button>
        </Form>
      </div>
    </div>
  );
};